import Hero from "./Hero";
import News from "./News";

function Latest() {
  return (
    <div>
      <Hero />
      <News />
    </div>
  );
}

export default Latest;
